import { Link } from "react-router-dom";
import { useSeo } from "../components/site/Layout";
import { PageHero, Section, CtaBand, ThirdPartyNotice } from "../components/site/blocks";
import { Reveal } from "../components/site/Reveal";
import { IMAGES } from "../data/site";

export const METHOD_STEPS = [
  { t: "Échange", d: "Vous décrivez votre besoin ; réponse sous 48 h ouvrées.", more: "Par formulaire, email ou rendez-vous en ligne. Nous clarifions le besoin, les délais et les documents utiles." },
  { t: "Diagnostic", d: "Visite sur place et rapport écrit clair.", more: "Analyse des usages, relevés, contraintes techniques, éligibilité aux aides. Préconisations priorisées et budget indicatif." },
  { t: "Aides & devis", d: "Dossiers d'aides montés, devis comparés.", more: "Consultation d'entreprises qualifiées et assurées, analyse comparative, dépôt des dossiers avant tout démarrage." },
  { t: "Travaux & clôture", d: "Coordination, contrôle, réception.", more: "Planification, suivi de chantier, levée des réserves et demandes de versement des aides." },
];

export default function Methode() {
  useSeo("Notre méthode", "La méthode Habitalys en quatre étapes : échange, diagnostic, aides & devis, travaux & clôture.");
  return (
    <>
      <PageHero eyebrow="Méthode" title="Quatre étapes, zéro surprise" intro="Chaque étape produit un livrable clair. Vous décidez à chaque fois." image={IMAGES.advisor} imageAlt="Conseillère présentant un plan sur tablette à un couple de seniors" />
      <Section testid="method-steps">
        <ol className="grid md:grid-cols-2 gap-4">
          {METHOD_STEPS.map((s, i) => (
            <Reveal as="li" key={s.t} delay={i * 80} data-testid={`method-step-${i + 1}`}>
              <details className="group rounded-3xl border border-brand/15 bg-white p-6 sm:p-8 open:bg-brand-50 transition-colors h-full">
                <summary className="list-none cursor-pointer">
                  <span className="font-display text-5xl text-brand-200">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="mt-3 text-2xl">{s.t}</h2>
                  <p className="mt-1 text-slate-600">{s.d} <span className="text-brand-ink font-semibold group-open:hidden">En savoir plus</span></p>
                </summary>
                <p className="mt-4 text-slate-700">{s.more}</p>
              </details>
            </Reveal>
          ))}
        </ol>
        <ThirdPartyNotice className="mt-8" />
        <Link to="/prendre-rdv" className="btn-accent mt-8" data-testid="method-rdv-cta">Réserver un diagnostic</Link>
      </Section>
      <CtaBand />
    </>
  );
}
